module.exports = __webpack_public_path__ + "media/images/common/ico-lp-about-frozen-7330eb7c97c59f18045df50ffa5ef3e5.svg";